import { useMemo } from 'react';
import { useGetList, useList } from 'react-admin';

type WithdrawalWithCorrelationId = {
  id: number;
  correlation_id: string;
};

export const useRelatedWithdrawals = <Withdrawal extends WithdrawalWithCorrelationId>({
  record,
  resource,
}: {
  record: WithdrawalWithCorrelationId | undefined;
  resource: string;
}) => {
  const { data, isLoading } = useGetList<Withdrawal>(
    resource,
    {
      filter: { correlation_id: record?.correlation_id },
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'id', order: 'ASC' },
    },
    {
      enabled: record !== undefined,
    },
  );

  const relatedWithdrawals = useMemo(
    () => data?.filter((withdrawal) => withdrawal.id !== record?.id) ?? [],
    [data, record?.id],
  );

  const listContext = useList({
    data: relatedWithdrawals,
    isLoading,
  });

  return {
    listContext,
    relatedWithdrawals,
    hasRelatedWithdrawals: relatedWithdrawals.length > 0,
  };
};
